import styled from '@emotion/styled'
import { Typography } from '@mui/material'

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const StyledRichTextEditor = styled('div')`
    .ProseMirror {
        height: 476px;
        overflow-y: auto;
    }
`
export const ValueTypography = styled(Typography)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`
